import keyMirror from 'keymirror';

export default keyMirror({
  RECEIVE_VERSION: null,
  RECEIVE_VERSION_ERROR: null
});
